"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var react_cookie_consent_1 = __importDefault(require("react-cookie-consent"));

var components_1 = require("@lsg/components");

var wording = {
  en: {
    message: "This website uses cookies, to improve it's usability",
    readMore: 'Read more',
    to: 'https://www.commerzbank.de/portal/en/footer1/recht/rechtliche_hinweise.html'
  },
  de: {
    message: 'Diese Webseite verwendet Cookies, um die Nutzerfreundlichkeit zu verbessern',
    readMore: 'Mehr lesen',
    to: 'https://www.commerzbank.de/portal/de/footer1/recht/rechtliche_hinweise.html'
  }
};
var overlayStyles = {
  position: 'fixed',
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,.9)',
  padding: '16px 60px 16px 32px',
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: '880px',
  left: '50%',
  transform: 'translateX(-50%)',
  boxShadow: '0px 0px 35px 5px rgba(0,0,0,0.25)'
}; // hacky! But this invisible Button is needed for the plugin functionality

var buttonStyles = {
  position: 'absolute',
  right: '0',
  top: '50%',
  transform: 'translateY(-50%)',
  width: ' 60px',
  height: '100%',
  cursor: 'pointer',
  opacity: 0
};

var IconButton = function IconButton() {
  return React.createElement(ButtonWrapper, null, React.createElement(components_1.Icon, {
    name: "interaction___checkmark",
    color: components_1.Icon.Colors.WHITE
  }));
};

var LWSCookieConsent = function LWSCookieConsent(_a) {
  var _b = _a.lang,
      lang = _b === void 0 ? 'de' : _b,
      _c = _a.cookieName,
      cookieName = _c === void 0 ? 'userConsentCookie' : _c; // showConsent is the placeholder for checking wether or not the cookie was set on the commerzbank page
  // the npm plugin we are using, detectsautomatically if a cookie with the same name was set already

  var showConsent = true;
  var text = wording[lang];
  return showConsent && React.createElement(CookieConsentWrapper, null, React.createElement(react_cookie_consent_1["default"], {
    disableStyles: true,
    location: "bottom",
    cookieName: cookieName,
    style: overlayStyles,
    expires: 365,
    buttonText: "OK",
    buttonStyle: buttonStyles
  }, React.createElement(components_1.Paragraph, {
    noMargin: true
  }, text.message, React.createElement(components_1.Link, {
    href: text.to,
    target: "_blank",
    rel: "noopener noreferrer"
  }, text.readMore)), React.createElement(IconButton, null)));
};

exports.CookieConsent = LWSCookieConsent; // needed to add missing theming option for p in LSG components

var CookieConsentWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  p,\n  a {\n    color: white;\n  }\n  a {\n    margin: 0 16px;\n    :hover {\n      color: #c1c1c1;\n    }\n  }\n"], ["\n  p,\n  a {\n    color: white;\n  }\n  a {\n    margin: 0 16px;\n    :hover {\n      color: #c1c1c1;\n    }\n  }\n"]))); // needed to overwrite LSG component bug

var ButtonWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  svg {\n    color: #fff;\n    fill: #fff;\n  }\n"], ["\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  svg {\n    color: #fff;\n    fill: #fff;\n  }\n"])));
var templateObject_1, templateObject_2;